// Must match the server's double-submit cookie name exactly (AuthCookie.CsrfCookieName
// = "msk_csrf"). Reading the wrong name yields no token, so the X-CSRF-Token header is
// omitted and every state-changing request is rejected 403 CSRF_INVALID (FLOWBUG-002).
const CSRF_COOKIE_NAME = 'msk_csrf';

export function readCsrfCookie(): string | null {
  const m = document.cookie.match(new RegExp(`(?:^|;\\s*)${CSRF_COOKIE_NAME}=([^;]+)`));
  return m ? decodeURIComponent(m[1]!) : null;
}
